import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Label = styled.label`
  padding: 0.375rem;
  border-radius: 50px;
  display: inline-flex;
  cursor: pointer;
  transition: background 0.2s ease;

  & input {
    position: relative;
    width: 1.5em;
    height: 1.5em;
    border-radius: 10px;
    background: none;
    border: 1px solid #9f9f9f;
    appearance: none;
    transition: background 200ms ease;
    pointer-events: none;
    outline: none;

    &::before {
      position: absolute;
      content: "";
      display: block;
      top: 2px;
      left: 6px;
      width: 4px;
      height: 10px;
      border-style: solid;
      border-color: white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      opacity: 0;
    }

    &:checked {
      color: white;
      background: ${theme.colors.primary};
      border-color: ${theme.colors.primary};

      &::before {
        opacity: 1;
      }
    }
  }

  > span {
    vertical-align: middle;
    display: inline-block;
    line-height: 20px;
    padding: 0 0.5rem;
    user-select: none;
  }
`;
